<script module lang="ts">
  import { crossfade, fade } from 'svelte/transition';

  export const [send, receive] = crossfade({});
</script>

<script lang="ts">
  import { navigating, page } from '$app/state';
  import Loading from '~/components/Loading.svelte';
  import { dims } from './dimensions.svelte';
  import type { Snippet } from 'svelte';

  type Props = {
    loading?: boolean;
    children: Snippet;
  };
  const props: Props = $props();
  let key = $state(page.route.id + ',');
  // svelte-ignore state_referenced_locally
  let prevKey = $state(key);
  $effect(() => {
    if (navigating.to) {
      key = [navigating.to.route.id, navigating.to.params?.mode].join();
    } else {
      prevKey = key;
    }
  });
  let duration = 500;
</script>

{#key key}
  <div
    class="page"
    style:padding="{dims.pad}px"
    in:fade={{ duration, delay: duration }}
    out:fade={{ duration }}
  >
    {#if props.loading || (navigating.to && key !== prevKey)}
      <Loading />
    {:else}
      {@render props.children()}
    {/if}
  </div>
{/key}

<style lang="scss">
  .page {
    position: relative;
    width: 100%;
    height: 100%;
    grid-row: 1 / 2;
    grid-column: 1 / 2;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
</style>
